import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  shell: {
    minHeight: '100vh'
  },

  topbar: {
    background: token.colorBgContainer,
    borderBlockEnd: `1px solid ${token.colorBorderSecondary}`,
    padding: `0 ${token.paddingLG}px`,
    height: 48,
    minHeight: 48,
    lineHeight: '1 !important' as unknown as string
  },

  brand: {
    display: 'inline-flex',
    alignItems: 'center',

    '& img': {
      maxHeight: 20
    }
  },

  dividerY: {
    width: 1,
    alignSelf: 'stretch',
    height: 24,
    background: token.colorBorderSecondary,
    marginInline: token.marginXXS
  },

  user: {
    paddingInline: token.paddingXS
  },

  userName: {
    fontSize: token.fontSizeSM,
    fontWeight: token.fontWeightStrong,
    color: token.colorText,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 160
  },

  userMenu: {
    minWidth: 260,
    background: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
    overflow: 'hidden'
  },

  userMenuHeader: {
    padding: token.padding
  },

  /**
   * Bare mode: a flex container so the single child — a full-screen flow that
   * owns its own layout — sits centred on the vertical axis instead of hugging
   * the top of a taller viewport.
   */
  // One white sheet: the wordmark and the links sit on the same background as
  // the card between them. `min-height` rather than `height` — a screen too
  // short for the flow still scrolls, which is the honest outcome; what must
  // not happen is a scrollbar appearing while there is room to spare.
  publicShell: {
    minHeight: '100vh',
    background: token.colorBgContainer
  },

  publicBrandRow: {
    flexShrink: 0,
    padding: `${token.padding}px ${token.paddingLG}px 0`,

    a: {
      display: 'inline-block',
      maxWidth: 150,
      lineHeight: 0
    }
  },

  publicFooter: {
    flexShrink: 0,
    rowGap: 4,
    padding: `0 ${token.paddingLG}px ${token.padding}px`,

    '.ant-typography': {
      textDecorationLine: 'none'
    },

    '.ant-typography:hover, .ant-typography:focus-visible': {
      textDecorationLine: 'underline'
    }
  },

  bareContent: {
    flex: 1,
    // Without this a flex child refuses to shrink below its content, and the
    // card would push the footer off the bottom of the viewport.
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${token.paddingXS}px ${token.paddingLG}px`,
    // White rather than the app's grey page background: the flow that fills
    // this slot is one card whose own halves carry the contrast, and a grey
    // page around it added a third tone for no reason.
    background: token.colorBgContainer
  },

  content: {
    flex: 1,
    padding: `${token.paddingLG}px ${token.paddingLG}px ${token.paddingXL}px`,
    background: token.colorBgLayout
  }
}))
